import { PRODUCT_TAG_FREE_SHIPPING } from '../../../constants/product';
import { ProductContextEntry } from '../../../providers/ProductProvider';

export type CheckoutWork = {
  id: string;
  freeShipping?: boolean;
  title: string;
  price: number;
  imageSrc: string;
  imageAlt: string;
  quantity?: number;
  quantityLimit?: number;
  allowMultiple?: boolean;
  soldOut?: boolean;
};

const workImage = (
  entry: ProductContextEntry,
): { alt: string; src: string } => {
  const { backendProduct, storyblokProduct } = entry;
  const title = backendProduct?.title ?? '';

  if (backendProduct?.thumbnail?.url) {
    return {
      alt: backendProduct.thumbnail.alt ?? title,
      src: backendProduct.thumbnail.url,
    };
  }

  const firstImage = backendProduct?.images?.find((image) => image.url);
  if (firstImage?.url) {
    return { alt: firstImage.alt ?? title, src: firstImage.url };
  }

  if (
    storyblokProduct?.component === 'product_v2' &&
    storyblokProduct.ogImage?.filename
  ) {
    return {
      alt: storyblokProduct.ogImage.alt ?? title,
      src: storyblokProduct.ogImage.filename,
    };
  }

  return { alt: title, src: '' };
};

export const buildCheckoutWork = (entry: ProductContextEntry): CheckoutWork => {
  const image = workImage(entry);

  return {
    freeShipping:
      entry.shopifyPurchaseDetails?.freeShipping ??
      entry.backendProduct?.tags?.includes(PRODUCT_TAG_FREE_SHIPPING) ??
      false,
    id: entry.shopifyId,
    imageAlt: image.alt,
    imageSrc: image.src,
    price:
      entry.shopifyPurchaseDetails?.price ?? entry.backendProduct?.price ?? 0,
    title:
      entry.backendProduct?.title ?? entry.shopifyPurchaseDetails?.name ?? '',
  };
};
